import { useQuery } from '@tanstack/react-query';

import { handleError } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { SUMMARY_BASE_PATH } from '../../constants/summaryBasePath';
import { getSummaryComponentsForApplication } from '../../requests/getSummaryComponentsForApplication';

export const useSummaryComponents = (
  definitionName: string,
  summaryId: string | undefined,
  documentUuid: string,
) => {
  const { constructGet } = useRequestConstructor();
  const path = summaryId ? `${summaryId}/document/${documentUuid}` : undefined;

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getSummaryComponentsForApplication>>
  >({
    queryKey: [SUMMARY_BASE_PATH, definitionName, 'components', path],
    queryFn: () =>
      getSummaryComponentsForApplication(constructGet, definitionName, path!),
    enabled: Boolean(summaryId) && Boolean(documentUuid),
    onError: () => handleError('Could not load application summary.'),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'summaryComponents'),
    ...rest,
  };
};
